import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

/* Icewall .box: bg slate-50, hairline border, soft shadow + offset frame below */
export default function Card({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('box p-5', className)} {...props}>
      {children}
    </div>
  )
}

export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mb-3 text-base font-medium text-foreground', className)}>{children}</div>
}
